import React from 'react';
import { Box, DotsLoader } from '@drone-js/core';
import { useSelector } from 'react-redux';

import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

export const Loader: React.FC<{ element: string }> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);

    // We might want to use variant brand later when Drone.js fix for all whitelabel
    return (
        <Box height="360px" display="flex" justifyContent="center" alignItems="center" data-testid={`activities-data-loader-${props.element}`}>
            <DotsLoader label={cms[326495]} variant="primary" />
        </Box>
    );
};
Loader.displayName = 'Loader';
